export const StructureTypeKey = 'structure-type';
export const StructureTypeByCodeKey = 'structure-type-by-code';